import { render, staticRenderFns } from "./PinnedMessageBar.vue?vue&type=template&id=f15fef06"
import script from "./PinnedMessageBar.vue?vue&type=script&lang=js"
export * from "./PinnedMessageBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports